package com.nonopn.skywatcher.common.app.pages.administrators

import com.nonopn.skywatcher.common.app.api.impl.ApiInterface
import com.nonopn.skywatcher.common.app.api.impl.ThunderDetectionUser
import com.nonopn.skywatcher.common.app.api.impl.ThunderDetectionUsers
import com.nonopn.skywatcher.common.app.pages.sentinels.ThunderDetection
import com.nonopn.skywatcher.common.app.pages.sentinels.ThunderDetectionWithMetadata
import com.nonopn.skywatcher.design.widgets.abslists.AbstractListModel
import com.nonopn.skywatcher.design.widgets.abslists.ListModelState
import com.nonopn.skywatcher.design.widgets.abslists.ListModelStateHolder

private const val Millis = 1000.0

@Suppress("TooManyFunctions")
class AdministratorsModel(
    private val thunderDetection: ThunderDetectionWithMetadata,
    private val currentApi: ApiInterface,
    private val usersOrAdminMode: UserMode,
) : AbstractListModel<AdministratorsModelState, ThunderDetectionUser>(
    AdministratorsModelState(
        isLoading = true,
        canInvite = false,
    )
) {
    override fun load() {
        call { currentApi.users(thunderDetection) }
    }

    fun inviteToSentinel(email: String, onSuccess: () -> Unit, onError: () -> Unit) {
        call(
            onSuccess = onSuccess,
            onError = onError,
        ) {
            currentApi.addUser(
                thunderDetection,
                email = email,
                isAdministrator = UserMode.Admin == usersOrAdminMode,
                validUntilSeconds = null
            )
        }
    }

    fun removeFromSentinel(
        user: ThunderDetectionUser,
        onSuccess: () -> Unit,
        onError: () -> Unit
    ) {
        call(
            onSuccess = onSuccess,
            onError = onError,
        ) {
            currentApi.removeUser(thunderDetection, user)
        }
    }

    private fun call(
        onSuccess: () -> Unit = { /* nothing */ },
        onError: () -> Unit = { /* nothing */ },
        action: suspend () -> ThunderDetectionUsers
    ) {
        safeLaunch {
            try {
                updateState {
                    copy(
                        modelState = modelState.copy(ListModelState.LOADING)
                    )
                }

                val result = action()
                //no management of filter for now, the whole list will be returned everytime

                println(result)

                val users = when (usersOrAdminMode) {
                    UserMode.User -> result.users.filter { !it.isAdministrator }
                    UserMode.Admin -> result.users.filter { it.isAdministrator }
                }

                updateState {
                    copy(
                        isLoading = false,
                        canInvite = result.canInvite,
                        modelState = modelState.copy(
                            ListModelState.LOADED,
                            users,
                            filtered = users
                        )
                    )
                }

                onSuccess()
            } catch (err: Throwable) {
                err.printStackTrace()

                val lastState = if (states.value.modelState.objects.isNotEmpty()) {
                    ListModelState.LOADED
                } else {
                    ListModelState.ERROR
                }

                updateState {
                    copy(
                        isLoading = false,
                        canInvite = false,
                        modelState = modelState.copy(lastState)
                    )
                }

                onError()
            }
        }
    }

    override fun onNewStateHolder(newHolder: ListModelStateHolder<ThunderDetectionUser>) {
        updateState {
            copy(modelState = newHolder)
        }
    }

    override fun isMatch(entity: ThunderDetectionUser, filter: String): Boolean {
        if (filter.isEmpty()) return true
        return entity.email.lowercase().contains(filter.lowercase())
    }
}

enum class UserMode {
    User,
    Admin
}
